export function FooterCTA() {
  return (
    <footer id="cta" className="bg-background border-t border-border">
      <div className="max-w-6xl mx-auto px-4 py-16 text-center">
        <h4 className="text-2xl md:text-3xl font-semibold mb-3 text-foreground">Join the Dedox community</h4>
        <p className="text-muted-foreground mb-6">Zero-fee perps. Hybrid mechanism. Built on Hedera.</p>
        <div className="flex items-center justify-center gap-3 flex-wrap">
          <a href="#home" className="rounded-full px-5 py-2 border border-border hover:bg-muted transition-colors">Website</a>
          <a href="#features" className="rounded-full px-5 py-2 border border-border hover:bg-muted transition-colors">Docs</a>
          <a href="#home" className="rounded-full px-5 py-2 border border-border hover:bg-muted transition-colors">Community</a>
          <a href="#home" className="rounded-full px-5 py-2 border border-border hover:bg-muted transition-colors">Twitter</a>
        </div>
        <div className="mt-10 text-xs text-muted-foreground">
          <a href="#home" className="hover:text-foreground">Home</a>
          <span className="mx-2">•</span>
          <a href="#features" className="hover:text-foreground">Features</a>
        </div>
        <p className="mt-4 text-xs text-muted-foreground">© {new Date().getFullYear()} Dedox. All rights reserved.</p>
      </div>
    </footer>
  );
}


